module.exports = __webpack_public_path__ + "img/whatInReportImage1.9586311b.png";